import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowRightCircleIcon, 
  DocumentPlusIcon 
} from "@heroicons/react/24/solid";

const CategoryCard = ({ category }) => {
  const navigate = useNavigate();

  const getTools = () => {
    try {
      navigate("/catgtools", { 
        state: { 
          categoryId: category._id, 
          categoryName: category.name 
        } 
      });
    } catch (error) {
      console.error('Error navigating to category tools:', error);
    }
  };

  return (
    <div className="group relative overflow-hidden bg-white border border-gray-200 rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-2 transform">
      {/* Background Gradient Layer */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-blue-100 opacity-0 group-hover:opacity-50 transition-opacity duration-300 z-0"></div>
      
      {/* Card Content */}
      <div className="relative z-10 p-6">
        <div className="flex items-center space-x-4">
          {/* Category Icon/Logo */}
          <div className="bg-blue-100 p-3 rounded-full shadow-md group-hover:bg-blue-200 transition-colors">
            {category.logo ? (
              <img 
                src={category.logo} 
                alt={`${category.name} logo`} 
                className="w-10 h-10 object-contain"
              />
            ) : (
              <DocumentPlusIcon className="w-10 h-10 text-blue-600" />
            )}
          </div>
          
          {/* Category Details */}
          <div className="flex-1">
            <h3 className="text-xl font-bold text-gray-800 group-hover:text-blue-800 transition-colors">
              {category.name}
            </h3>
            <p className="text-gray-600 text-sm line-clamp-2">
              {category.description}
            </p>
          </div>
        </div>
        
        {/* Explore Button */}
        <button onClick={getTools}
          className="mt-4 w-full flex items-center justify-center space-x-2 px-4 py-2 bg-blue-500 text-white rounded-lg 
                     hover:bg-blue-600 transition-colors duration-300 group/button">
          <span>Explore Tools</span>
          <ArrowRightCircleIcon 
            className="w-5 h-5 transform transition-transform group-hover/button:translate-x-1" 
          />
        </button>
      </div>
      
      {/* Hover Effect Border */}
      <div className="absolute inset-0 border-2 border-transparent group-hover:border-blue-300 rounded-xl transition-all duration-300 pointer-events-none"></div>
    </div>
  );
};

export default CategoryCard;